import { createFileRoute } from '@tanstack/react-router';
import { ErrorPage } from '@/components/ErrorPage';
import { useAuth } from '@/context/useAuth';
import { Management } from '@/features/management/components/ManagementTable';

export const Route = createFileRoute('/gestion/general')({
  component: GeneralPage,
});

// Checked at render rather than in `beforeLoad`: on a direct page load the router runs
// `beforeLoad` once, while the session is still pending, and never re-runs it when it resolves.
function GeneralPage() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <ErrorPage
        title="Accès non autorisé"
        message="Vous n'avez pas l'autorisation d'accéder à cette page. Seuls les administrateurs peuvent accéder à la gestion générale."
      />
    );
  }

  return <Management />;
}
